(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('TaxCodeDeleteController',TaxCodeDeleteController);

    TaxCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxCode'];

    function TaxCodeDeleteController($uibModalInstance, entity, TaxCode) {
        var vm = this;

        vm.taxCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TaxCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
